import { useEffect, useRef } from 'react';

/**
 * Run a callback function in a defined interval. When the delay is null, interval is paused.
 * 
 * @example
 * useInterval(() => {
			 // Do somehing
			 setMyState(value);
		 }, isPaused ? null : 1000
	 );
 * 
 * Implementation completely taken from: https://overreacted.io/making-setinterval-declarative-with-react-hooks/
 * Written by Dan Abramov
 * 
 * 
 * @param {Function} callback Function to be executed
 * @param {number | null} delay Delay in ms or null to pause interval
 */
function useInterval(callback, delay) {
	const savedCallback = useRef();

	// Remember the latest callback.
	useEffect(() => {
		savedCallback.current = callback;
	}, [callback]);

	// Set up the interval.
	useEffect(() => {
		function tick() {
			savedCallback.current();
		}
		if (delay !== null) {
			const id = setInterval(tick, delay);
			return () => clearInterval(id);
		}
	}, [delay]);
}

export default useInterval;
